/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/hui/GetUserInfo',
    queryPlayer : '/api/user/getNickName',
    bind : '/api/hui/bind',
    my_task : '/api/UserTask/GetDict',
    evt_history : '/api/Order/GetOrderList',//历史记录
    task_apply : '/api/UserTask/RwTaskId',
    pack_config : '/api/Lyb/List',
    pack_apply : '/api/Lyb/BuyZx',
    invite_list : '/api/Lyb/BindList',//邀请列表
    buff_list : '/api/Share/GetList?mode=2',//buff邀请列表
    invite : '/api/Share/GetCode',//邀请 mode:1 消费邀请 ，2:百亿补贴助力邀请
    invite_info : '/api/Share/GetNickName',
    apply_invite : '/api/Lyb/BindBaoKu',
    apply_butie : '/api/Lyb/BindBuTie',
    get_buff : '/api/Lyb/GiftBindBuTie',//领取百亿补贴助力
    shop_list : '/api/Lyb/GetBybtShop',//获取百亿补贴商店
    add_cart : '/api/Lyb/AddByCart',//加入购物车
    del_cart : '/api/Lyb/RmvByCart',//删除购物车
    cart_list : '/api/Lyb/GetByCart',//获取购物车
    cart_submit : '/api/Lyb/BuyBybt',//百亿补贴购买
    score_list : '/api/Gift/List?gid=6&orderNum=true',//积分兑换列表
    score_trade : '/api/gift/Reward',
    score_info : '/api/user/getScore',//积分
    record : '/api/Order/GetOrderList',//
}

export const apiUserinfo = p => get(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryPlayer, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiTaskinfo = p => get(user_api.my_task, p);
export const apiHistoryinfo = p => get(user_api.evt_history, p);
export const apiPackConfig = p => get(user_api.pack_config, p);
export const apiPackApply = p => post(user_api.pack_apply, p);
export const apiInviteList = p => get(user_api.invite_list, p);
export const apiBuffList = p => get(user_api.buff_list, p);
export const apiInviteCode = p => get(user_api.invite, p);
export const apiInviteInfo = p => get(user_api.invite_info, p);
export const apiInviteApply = p => post(user_api.apply_invite, p);
export const apiButieBind = p => post(user_api.apply_butie, p);
export const apiShopList = p => get(user_api.shop_list, p);
export const apiAddCart = p => post(user_api.add_cart, p);
export const apiDelCart = p => post(user_api.del_cart, p);
export const apiCartList = p => get(user_api.cart_list, p);
export const apiCartApply = p => post(user_api.cart_submit, p);
export const apiScoreList = p => get(user_api.score_list, p);
export const apiScoreApply = p => post(user_api.score_trade, p);
export const apiGetBuff = p => post(user_api.get_buff, p);
export const apiUserRecord = p => get(user_api.record, p);
export const apiUserScore = p => get(user_api.score_info, p);